import { SVGIconProps } from "@faire/slate-icons/types";
import React from "react";

import { resolveToastAccessory } from "./resolveToastAccessory";
import { ToastAccessory } from "./ToastAccessory";
import { ToastCloseButton } from "./ToastCloseButton";
import { ToastCtaButton } from "./ToastCtaButton";
import { ToastAccessory as ToastAccessoryProp } from "./types";

// Copying the props from the Toast component to allow storybook to find the props
type IProps = {
  /**
   * Optional call-to-action label, rendered on its own row below the description.
   */
  cta?: string;

  /**
   * The content of the toast.
   */
  description: string;

  /**
   * Leading accessory. Omit for none.
   */
  accessory?: ToastAccessoryProp;

  /**
   * @deprecated Use `accessory={{ type: "icon", Icon }}` instead.
   * Still supported; equivalent to an icon accessory when `accessory` is omitted.
   */
  Icon?: React.FC<SVGIconProps>;

  /**
   * **web**
   * The callback invoked when the CTA is actioned.
   */
  onCtaClick?: () => void;

  /**
   * **web**
   * The callback invoked when the toast is closed or the CTA is actioned (Toast always closes when CTA is actioned).
   */
  onDismiss?: () => void;

  "data-component-name"?: string;
};

export const ToastBase = ({
  description,
  accessory,
  Icon,
  onDismiss,
  cta,
  onCtaClick,
  "data-component-name": dataComponentName,
}: IProps) => {
  const resolvedAccessory = resolveToastAccessory({ accessory, Icon });

  return (
    <div
      className="fs-toast__content fs-toast--default"
      data-component-name={dataComponentName}
    >
      <ToastAccessory accessory={resolvedAccessory} />
      <div className="fs-toast__body">
        <span className="fs-toast__description">{description}</span>
        {cta ? (
          <ToastCtaButton
            onClick={() => {
              onCtaClick?.();
              onDismiss?.();
            }}
          >
            {cta}
          </ToastCtaButton>
        ) : null}
      </div>
      <ToastCloseButton className="fs-toast__close" onClick={onDismiss} />
    </div>
  );
};
